import { EventShop } from "../../../../../shop/frontend/web/js/classes/EventShop.js";
 
/**
 *  Класс с методами, которые нужны на странице мероприятия и корзины
 * @extends EventShop
 */
export class Event extends EventShop {
	constructor() {
		super();
		this.$promo = $(".js-promo");
		this.$placesChange = null;
		this.$count = $(".js-count");
		this.$currentCount = this.$count;
		this.$countWord = $(".js-count-word");
		this.$sum = $(".js-sum");
		this.$previousHtml = null;
		this.$placesInfo = null;
		this.$placesLegend = null;
		this.$placeToSvg = null;
		this.$svg = null;
		this.$tickets = null;
		this.$svgElement = null;
		this.$elements = null;
		this.$placesChoose = null;
		this.$placesBack = null;
		this.$pricesReset = null;
		this.$clearButton = $("#js-order-clear");
		this.storage = window.storage;
		this.storageLimit = window.storageLimit;
		this.views = null;
		this.overlay = $("#js-overlay");
		super.initShop();
	}

	initFrontend() {
		this.getLanguages();
		this.setUpListeners();
	}

	setUpListeners() {
		$(document).on("click", ".js-promo .promo__button", e => {
			const element = $(e.target);
			this.eventId = element.parents(".js-promo").data("event");
			const orderId = element.data("order");
			const code = element.parents(".js-promo").find(".promo__input").val();
			const orderItem = element.parents(".order__item");

			this.applyPromocode(orderId, orderItem, code);
		});

		$(document).on("keydown", ".js-promo .promo__input", e => {
			const element = $(e.target);
			this.eventId = element.parents(".js-promo").data("event");
			const code = element.val();
			const orderId = element.data("order");
			const orderItem = element.parents(".order__item");

			if (e.which === 13 || e.keyCode === 13 || e.key === "Enter") {
				this.applyPromocode(orderId, orderItem, code);
			}
		});

		$(document).on("click", ".js-tickets-remove", e => {
			const element = e.currentTarget;
			const item = $(element).parents(".tickets__item");
			const itemPrice = $(item).find(".js-ticket-price").text();
			const parent = $(element).parents(".tickets_order"); //родитель билетов если удаляем из корзины
			const sid = item.data("place");
			this.eventId = item.data("event");
			this.removeFromCart(sid);
			if (parent && parent.length > 0) {
				//если удаляем из корзины то обновить стоимость конкретного мероприятия
				if (itemPrice && +itemPrice >= 0) {
					this.updateCurrentEventSum(+itemPrice, parent);
				}
			}
			$(`#${sid}`).data("available", "true");
		});

		$(document).on("click", "#js-order-pull", e => {
			const element = $(e.currentTarget);
			element.parents(".order__pull").toggleClass("active");
			$("#js-places-change").toggleClass("inactive");
			$(".order").toggleClass("opened");
			$(".places__middle").toggleClass("inactive");
			$(".js-tickets").toggleClass("active");
			$(".modal_mobile-event .modal__content").toggleClass("active");
		});

		this.removeFull();

		$(document).on("click", ".js-direct-to-order", e => {
			window.location.replace("/orders/cart");
		});
	}

	actionAfterRemove() {
		$(".order").removeClass("active");
		$(".order__pull").removeClass("active");
		$("#js-places-change").removeClass("inactive");
		$(".order").removeClass("opened");
		$(".places__middle").removeClass("inactive");
		$(".js-tickets").removeClass("active");
		$(".modal_mobile-event .modal__content").removeClass("active");
	}

	updateSeats() {}

	updateZones(res) {
		let arr = Object.values(res.zones);
		let com = [];
		for (let i = 0; i < arr.length; i++) {
			for (let j = 0; j < com.length; j++) {
				if (com[j] && arr[i]) {
					if (com[j].price === arr[i].price) {
						com[j].free += arr[i].free;
						arr.splice(i, 1);
					}
				}
			}

			if (!com[i] && arr[i]) {
				com.push(arr[i]);
			}
		}
		let obj = {};
		obj.zones = { ...com };
		return obj;
	}

	addActionToBack() {
		$(document).on("click", "#js-places-back", e => {
			$(e.currentTarget).removeClass("active"); //скрыть кнопку назад
			// this.$placeToSvg.fadeOut("fast", () => {
			//плавно скрывает план сектора
			this.isSectorPlan = false;
			this.$placeToSvg.html(this.$previousHtml);
			this.setIsSectorPlan();
			this.$stadiumPlace = $("#js-stadium-place");
			this.setTags();
			this.getZones().then(res => {
				this.setZones(this.updateZones(res));
				this.addActionToPricesLabelToSector();
			});
			$(".order.order_event").removeClass("sector-plan");
			this.$prices.hide();
			this.$placesLegend.show();
			this.$placesInfo.addClass("places__info_sector");
			this.$placesChoose.hide();
			this.$svgElement = $(".js-svg svg");
			this.$elements = this.$svgElement.find("g[mode]");
			this.$stadium.removeAttr("hidden");
			this.setSvgPlan();
			this.setPricesLabelToSector();
			if (!this.isDesktop.matches) {
				$("#js-places-info").after(this.$prices);
			}
			this.$prices.append(
				$(`<div class="places__info-item places__info-item_work">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "your seats")}</div>
					</div>
					<div class="places__info-item places__info-item_disabled">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "not available")}</div>
					</div>`));
			// $(".places__info-item_sector").show();
			this.addActionToPricesLabelToSector();
			this.addStadium();
			if (this.views) {
				this.updateSeats(this.views);
			}
			this.$placesChange.removeClass("openedSector");
			this.$placeToSvg.fadeIn("slow"); //добавляет анимацию появления после загрузки
			// });
		});
	}

	addStadium() {
		this.$stadiumPlace = $("#js-stadium-place");
		if (!this.$stadiumPlace[0]) {
			return false;
		}
		const size = this.$stadiumPlace[0].getBoundingClientRect();
		this.stadiumHeight = size.height;
		this.stadiumWidth = size.width;
		const stadiumTop = size.top;
		const stadiumLeft = size.left;
		this.$stadium.css("width", this.stadiumWidth);
		this.$stadium.css("height", this.stadiumHeight);
		this.$stadium.css("top", stadiumTop);
		this.$stadium.css("left", stadiumLeft);

		$(document).on("scroll", () => {
			const size = this.$stadiumPlace[0].getBoundingClientRect();
			const stadiumTop = size.top;
			const stadiumLeft = size.left;
			this.$stadium.css("top", stadiumTop);
			this.$stadium.css("left", stadiumLeft);
		});
	}

	getPopup() {
		if (!this.isSectorPlan) {
			this.setColors().then(() => {
				this.setPricesLabelToPlace();
				this.addActionToPricesLabelToPlace();
			});
		}
		this.$popupModal.find(".modal-body").html(this.$places);
		this.$popupModal.find(".places").show();
		this.$popupModal.find(".places__top").show();
		if (!this.isSectorPlan) {
			$(".places__prices").show();
		}
		$(".places__middle").append($(".places__prices"));
		$(".places__middle").append($(".covid-message"));
		$(".places__cart").prepend($(".places__check-price"));
		$(".places__choose").after($(".places__legend"));
		$(".places__cart").prepend($(".places__info"));
		$(".places__cart").prepend($(".order__pull"));
		$(".places__name").after($("#js-event-date"));
		$(".places__content").prepend($("#js-header-popup"));
		$(".places__cost").after($("#js-bottom"));
		$(".places__legend").after($("#js-places-info"));
		$("#js-order-info").removeClass("hide");
		this.$tickets.hide();
		this.$popupModal.addClass("modal_mobile-event");
		this.$popupModal.modal();
		this.viewPromoButton();
		this.$svgElement = $("#js-svg svg");
		setTimeout(this.setSvgPlan.bind(this), 200);
		if (this.isSectorPlan) {
			this.$popupModal.find(".places").addClass("active");
			this.$placesChoose.hide();
			this.getZones().then(res => {
				this.setZones(this.updateZones(res));
				this.addActionToPricesLabelToSector();
			});
		}
	}

	setAddToCart(id) {}

	setTicketsItems(data, isClear = false) {
		if (isClear) {
			this.$ticketsItems.html("");
		}
		for (let i = 0; i < data.length; i++) {
			const item = data[i];
			const isPack = data[i].is_pack || data[i].isPack;
			if (!isPack) {
				$(`#${item.sid}`).addClass("in-cart");
				$(`#${item.id}`).addClass("in-cart");
			} else {
				$(`#${item.sid}`).data("ispack", true);
				$(`#${item.id}`).data("ispack", true);
			}
			const ticket = this.insertDataToTicket(item, isPack);
			this.$ticketsItems.append(ticket);
		}
	}

	addActionToSector() {
		this.$placesChange.addClass("active");
		this.$previousHtml = this.$placeToSvg.html();
		let sectorIndex;


		$(document).on("click", e => {
			e.stopPropagation();
			if (!this.isDesktop.matches && e.originalEvent) return false;
			const element = e.target;
			if ($(element).closest("g[view_id]").length) {
				this.$placeToSvg.fadeOut("fast"); //скрывает элемент при загрузке
				this.$stadium.removeClass("active"); //скрыть слайдер стадиона при нажатии на сектор
				this.$tooltip.hide();
				this.$placesInfo.removeClass("places__info_sector");
				this.isSectorPlan = false;
				this.$stadium.attr("hidden", "hidden");
				const activeSector = $(element).closest("g[view_id]");
				const view_id = activeSector.attr("sector_id") || activeSector.attr("view_id");
				window.currentViewId = view_id;
				const limit = (this.storageLimit || 3) * 60 * 1000; //Переводим в миллисекунды (по умолчанию 3 минуты)
				const unitId = this.unit_id;
				try {
					this.overlay.show();
					this.getSvgPrices(this.eventId, view_id, true).then(res => {
						try {
							this.overlay.show();
							this.overlay.hide();
							this.$placeToSvg.html(res.svg);
							this.addActionAfterOpenSector(res);
								
						} catch (e) {
							console.log(e);
						}
					})
					.finally(() => {
						this.overlay.hide();
					});
				} catch (e) {}

				this.$prices.show();
				this.$placesChange.addClass("openedSector");
				this.$placesBack.addClass("active");
				this.$placeToSvg.addClass("loading");
			}
		});
	}

	addActionToLoadSectorPrices(sectorLocal, view_id) {
		// this.$placeToSvg.fadeOut("fast", () => {
		this.$placeToSvg.html(sectorLocal.svg ? sectorLocal.svg : sectorLocal);
		this.showOpenedSector();
		// });
		const unitId = this.unit_id;

		this.getPrices(view_id, false).then(res => {
			try {
				this.overlay.show();
				this.storage
					.setItem(`${unitId}_${view_id}`, {
						...res,
						svg: sectorLocal.svg,
						time: +new Date(),
					})
					.then(() => {
						this.showActivePlacesOpenedSector(res);
					})
					.finally(() => {
						this.overlay.hide();
					});
			} catch (e) {}
		});
	}

	showOpenedSector() {
		//copied from addActionAfterOpenSector method
		this.$places.off();
		if (this.isDesktop.matches) {
			this.$placesLegend.hide();
		}
		this.$placesChoose.show();
		this.$svgElement = $(`.js-svg[data-id="${this.eventId}"]`).find("svg");
		this.$elements = this.$svgElement.find("g[mode]");
		this.$elements.addClass("default");
		this.updatePlan();
		this.setSvgPlan();
		this.$placeToSvg.fadeIn("slow"); //добавляет анимацию появления после загрузки
		this.$placeToSvg.removeClass("loading");
		// $(".places__info-item_sector").hide();
		$("#js-places-legend").hide();
	}

	showActivePlacesOpenedSector(res) {
		//copied from addActionAfterOpenSector method
		this.updatePlan();
		this.setColorToPlace(res);
		this.setActivePlaces();
		this.setPricesLabelToPlace();
		this.addActionToPricesLabelToPlace();
		this.addActionToPlace();
		this.setSvgPlan();
		if (!this.isDesktop.matches) {
			$("#js-places-info").after(this.$prices);
			this.$prices.append(
				$(`<div class="places__info-item places__info-item_work">
					<div class="places__info-color"></div>
					<div class="places__info-text">${this.getWord("main", "your seats")}</div>
				</div>
				<div class="places__info-item places__info-item_disabled">
					<div class="places__info-color"></div>
					<div class="places__info-text">${this.getWord("main", "not available")}</div>
				</div>`));
			$("#js-places-check-price").hide();
			$("#js-places-legend").hide();
			if (!Number($(".js-count").text()) >= 1) {
				$(".order.order_event").addClass("sector-plan");
			}
		}
		// $(".places__info-item_sector").hide();
		$("#js-places-legend").hide();
	}

	addActionAfterOpenSector(res) {
		this.$places.off();
		if (this.isDesktop.matches) {
			this.$placesLegend.hide();
		}
		this.$placesChoose.show();
		this.$svgElement = $(`.js-svg[data-id="${this.eventId}"]`).find("svg");
		this.$elements = this.$svgElement.find("g[mode]");
		this.$elements.addClass("default");
		this.updatePlan();
		const that = this;
		this.setColorToPlace(res);
		// setTimeout(() => that.setColorToPlace(res), 1000);
		this.setActivePlaces();
		this.setPricesLabelToPlace();
		if (!this.isDesktop.matches) {
			$("#js-places-info").after(this.$prices);
			this.$prices.append(
				$(`<div class="places__info-item places__info-item_work">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "your seats")}</div>
					</div>
					<div class="places__info-item places__info-item_disabled">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main","not available")}</div>
					</div>`));
			$("#js-places-check-price").hide();
			if (!Number($(".js-count").text()) >= 1) {
				$(".order.order_event").addClass("sector-plan");
			}
		}
		this.addActionToPricesLabelToPlace();
		this.addActionToPlace();
		this.setSvgPlan();
		this.$placeToSvg.fadeIn("slow"); //добавляет анимацию появления после загрузки
		this.$placeToSvg.removeClass("loading");
		$("#js-places-legend").hide();
	}

	addActionToPlace() {
		this.$places.on("click", e => {
			const element = e.target;
			if ($(element).closest("g.active").length) {
				const activeSector = $(element).closest("g.active");

				const sid = $(activeSector).attr("id");
				const isPack = $(activeSector).data("ispack");
				if (isPack) {
					$(activeSector).data("available", "true");
				}
				const isCart = $(activeSector).data("available");
				if (isCart === "true") {
					if (!isPack) {
						$(activeSector).data("available", "false");
					}
					this.setAddToCart(sid);
				} else if (isCart === "false") {
					$(activeSector).data("available", "true");
					this.removeFromCart(sid);
				}
			}
		});
	}

	setActivePlaces() {
		const ticketsItems = $(".tickets__item");
		$.each(ticketsItems, (index, element) => {
			const place = $(element).data("place");
			const isPack = $(element).data("ispack");
			if (place && !isPack) {
				$(`#${place}`).addClass("in-cart active");
				$(`#${place}`).data("available", "false");
				this.updateActiveSeat(place, true);
			}
			if (isPack) {
				$(`#${place}`).data("ispack", "true");
			}
		});
	}

	setColors() {
		return this.getPrices().then(res => {
			if (this.isSectorPlan) {
				this.setColorToPackPlaces(res);
				this.$placesCheckPrice.hide();
				this.$placesChoose.hide();
			} else {
				this.$elements.addClass("default");
				this.updatePlan();
				this.setColorToPlace(res);
				this.$placesLegend.hide();
				this.$placesCheckPrice.show();
				this.$placesChoose.show();
			}

			this.addActionToPlace();
			this.setActivePlaces();
			this.$places.addClass("active");
		});
	}

	setColorToPackPlaces(res) {
		$.each(res.prices, (index, element) => {
			const id = element.id;
			const zoneId = element.z;
			const zone = this.getZonePropertiesById(zoneId, res.zones);
			const color = zone.color;
			const selector = $(`#${id}`);
			selector.removeClass("default").addClass("active");
			selector.find("rect").css("fill", color);
			selector.find("ellipse").css("fill", color);
			selector.find("circle").css("fill", color);
			selector.data("ispack", "true");
			selector.data("zone", zone);
		});
	}

	addActionToPricesLabelToSector() {
		const that = this;
	
		function addAction(input) {
			if (input.is(":checked")) {
				const color = input.data("color");
				input
					.parents(".places__price")
					.find(".places__price-content")
					.css("border-color", color);
			} else {
				input.parents(".places__price").find(".places__price-content").removeAttr("style");
			}
			if ($(".places__price input:checked").length === 0) {
				$("g[view_id]").removeClass("inactive");
			} else {
				$("g[view_id]").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.attr("price"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-price="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("inactive");
						} else {
							el.removeClass("inactive");
						}
					}
				});
			}
			if ($(".places__price input:checked").length > 1) {
				$(".js-prices-reset").show(200);
			} else {
				$(".js-prices-reset").hide(200);
			}
		}

		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			addAction(input);
		});

		if (!this.isDesktop.matches) {
			$(".places__price").on("click", e => {
				const label = $(e.currentTarget);
				const input = label.find("input");
				if (input.is(":checked")) {
					input.removeAttr("checked");
				} else {
					input.attr("checked", "checked");
				}
				input.trigger("change");
			});
		}

		$(".places__price input").keypress(e => {
			if (e.which === 13) {
				const input = $(e.currentTarget);
				input[0].checked = !input[0].checked;
				addAction(input);
			}
		});

		$(document).on("click", ".js-prices-reset", e => {
			const reset = $(e.currentTarget);
			$(".places__price input").removeClass("active");
			$("g[view_id]").removeClass("inactive");
			reset.hide(200);
			$(".places__price input").removeAttr("checked");
			if (this.isDesktop.matches) {
				$(".places__price input").each((i, item) => {
					item.checked = false;
				});
			}
			$(".places__price-content").removeAttr("style");
		});
	}

	initTooltip() {
		$(document).on("mouseover", e => {
			const element = $(e.target);
			if (element.closest("g.active").length) {
				const activeSector = $(element).closest("g.active");
				const id = activeSector.attr("id");
				let name = activeSector.data("name");
				let price = activeSector.data("price");
				if (!name) {
					const ticketItem = $(`.tickets__item[data-place="${id}"]`);
					name = ticketItem.find(".js-ticket-place").text();
					price = ticketItem.find(".js-ticket-price").text();
				}

				this.addTooltip(activeSector, price, name);
			} else {
				this.$tooltip.hide();
				this.$tooltip.css({ left: 0, top: 0 });
			}
			if (element.closest("g[free]").length) {
				const activeSector = $(element).closest("g[free]");
				const name =
					activeSector.find("text").text() ||
					activeSector.attr("sector_name") ||
					activeSector.attr("sector-name");
				const price = activeSector.attr("price");
				const count = activeSector.attr("all");
				const free = activeSector.attr("free");
				this.addTooltip(activeSector, price, name, count, free);
			}
		});
	}

	removeFull() {
		this.$clearButton.on("click", () => {
			this.removeFullCart().then(res => {
				if (res.result) {
					window.location.reload();
				}
			});
		});
	}

	insertDataToTicket(item, isPack) {
		let sector = item.sector || item.view_id;
		let name = item.name;
		let level = item.level;
		let row = item.row;
		let place = item.col;
		const sid = item.sid || item.id;
		const currentEventId = item.event_id;

		if (!sector.includes("Сектор")) {
			sector = this.getWord("main", "Sector") + " " + sector;
		}

		let sectorLower = sector.toLowerCase();

		name = name.toLowerCase();

		if (!name.includes("Сектор") && !name.includes("сектор")) {
			name = this.getWord("main", "Sector") + " " + name;
		}

		name = name.toLowerCase();

		if (level) {
			name = name.replace(level, "");
		}

		name = name.replace(/\s+/g, " ");
		name = name.replace(sectorLower, "");

		let price;

		if (item.price) {
			price = item.price;
		} else {
			price = "";
		}

		return `<div class="tickets__item js-ticket-template" data-event="${currentEventId}" data-place="${sid}" data-uid="${
			item.uid
		}" data-ispack="${isPack}">
					<div class="tickets__content">
											<div class="tickets__sector">${sector}</div>

						<div class="tickets__place"><span class="js-ticket-place">${this.getWord(
							"main",
							"Row"
						)} ${row} ${this.getWord("main", "place")} ${place}</span>
						<span class="tickets__place-price">
						<span class="js-ticket-price">${price}</span>
						${this.getWord("main", "$")}</span>
					</div>
					<div class="tickets__remove js-tickets-remove">
						<button class="reset-btn tickets__remove-button"  type="button" data-selenium="event_seat_delete">Удалить</button>
					</div>
					</div>
					</div>`;
	}

	applyPromocode(orderId, orderItem, code) {
		function updatePromo(sale) {
			if (sale) {
				orderItem.find(".js-order-discount").show();
			}
		}

		this.setPromocode(orderId, code, updatePromo).then(res => {
			Object.entries(res.active_carts).forEach(([key, value]) => {
				const eventItem = orderItem.find(`.js-order-event[data-event-id="${key}"]`);
				eventItem.find(".js-order-event-sum").html(value.summ);
			});
		});
	}
}
